export const getSmsCode = {
    path:"/login/getSmsCode",
    method:"post"
}
export const loginByPhone = {
    path:"/login/loginByPhone",
    method:"post"
}
// 账号密码登录
export const loginByAccount = {
    path:"/login/loginByAccount",
    method:"post"
}
// 刷新令牌
export const refreshToken = {
    path:"/login/refreshToken",
    method:"post"
}
// 订单
// localhost:18081/xdk/?page=1&size=1
export const getUserCardOrder = {
    path:"/userCardOrder/getUserCardOrder",
    method:"get"
}
// 获取用户信息
export const getUserInfo = {
    path:"/userProfileInfo/getUserInfo",
    method:"POST"
}
export const getVipExpiresDate = {
    path:"/userMemberStatus/getVipExpiresDate",
    method:"POST"
}
export const bindMobile = {
    path:"/login/bindMobile",
    method:"POST"
}

// 安全验证
export const getAuthImg = {
    path:"/piccode/getPicCode",
    method:"POST"
}

export const getAuthCode = {
    path:"/piccode/checkClient",
    method:"POST"
}

// 微信授权
export const wechatAuth = {
    path:"/login/getWechatInfo",
    method:"POST"
}
// 微信授权登录
export const wechatLogin = {
    path:"/login/loginByWechat",
    method:"POST"
}
// export const getRealData={
//     path:"/business/getRealData",
//     method:"post"
// }
// 获取会员模板
export const getCardModel = {
    path:"/cardDefinition/getCardModel",
    method:"POST"
}
// 生成订单
export const buyCard = {
    path:"/userCardOrder/buyCard",
    method:"POST"
}
// 支付订单
export const toPayCardOrder = {
    path:"/pay/toPayCardOrder",
    method:"POST"
}
// 修改密码
export const forgetPassword = {
    path:"/login/forgetPassword",
    method:"POST"
}
export const upload = {
    path:"/common/upload",
    method:"POST"
}
export const updateUserProfileInfo = {
    path:"/userProfileInfo/updateUserProfileInfo",
    method:"POST"
}







// WEBPACK FOOTER //
// ./src/api/home.js